import { z } from "zod/v4";

export const IdentityMatchSchema = z.enum([
  "confirmed",
  "possible",
  "different",
]);
export const DealRelationshipSchema = z.enum(["owner", "broker"]);

export const ResearchEvidenceSchema = z.object({
  searchQuery: z.string().max(300).optional(),
  sourceTitle: z.string().max(300).optional(),
  sourceUrl: z.string().url(),
  snippet: z.string().max(500).optional(),
  whyItMatches: z.string().min(1).max(500),
  matchedClues: z.array(z.string().max(120)).max(8).default([]),
  conflicts: z.array(z.string().max(200)).max(6).optional(),
  identityMatch: IdentityMatchSchema.optional(),
  dealRelationship: DealRelationshipSchema.optional(),
  eventId: z.string().optional(),
  observationIds: z.array(z.string()).optional(),
  assessmentId: z.string().optional(),
  policyVersion: z.string().optional(),
  acceptance: z.enum(["apply", "candidate", "reject"]).optional(),
  requiresHumanReview: z.boolean().optional(),
  reviewQuestion: z.string().max(500).optional(),
  decisionConfidence: z.number().min(0).max(1).optional(),
  adjudicated: z.boolean().optional(),
  additionalReachChannel: z.boolean().optional(),
  issueKey: z.string().optional(),
  origin: z.enum(["intake", "manual", "research"]).optional(),
});

export type ResearchEvidence = z.infer<typeof ResearchEvidenceSchema>;

export const ResearchActivityHitSchema = z.object({
  title: z.string().max(300),
  url: z.string().max(2000),
  snippet: z.string().max(500).optional(),
});

export const ResearchActivityMetadataSchema = z.object({
  query: z.string().max(300).optional(),
  hits: z.array(ResearchActivityHitSchema).max(8).optional(),
  excerpt: z.string().max(500).optional(),
  reason: z.string().max(240).optional(),
  /** Full research closing note. The activity label stays short for the step list. */
  summary: z.string().max(8_000).optional(),
  policyVersion: z.string().optional(),
});

export type ResearchActivityMetadata = z.infer<
  typeof ResearchActivityMetadataSchema
>;

export function parseResearchEvidence(value: unknown): ResearchEvidence | null {
  const parsed = ResearchEvidenceSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
}
